/* eslint-disable no-case-declarations */
/* eslint-disable default-param-last */
import { actions, types } from './actions'
import { getMap, setGradientMapBoudaryLookup, populate, getMapDataSource } from './functions'

const initialState: MapVisualizer = {
    data: [],
    instanceSettings: {
        moduleTitle: '',
        moduleSubTitle: '',
        transactionStartDateTime: new Date(0),
        transactionEndDateTime: new Date(0),
        displayStartDateTime: new Date(0),
        displayEndDateTime: new Date(0),
        selectedControlIds: [],
        olsonTimezoneId: '',
        formTypeId: 0,
        scoreboardTypeId: 0,
        layoutSettings: {
            backgroundColor: { h: 0.0, s: 0.0, l: 0.0, a: 0.0 },
            defaultColor: { h: 0.0, s: 0.0, l: 0.0, a: 0.0 },
            fillColor: { h: 0.0, s: 0.0, l: 0.0, a: 0.0 },
            borderColor: { h: 0.0, s: 0.0, l: 0.0, a: 0.0 },
            titleFontSize: 0,
            titleColor: { h: 0.0, s: 0.0, l: 0.0, a: 0.0 },
            titleBold: false,
            titleItalic: false,
            subTitleFontSize: 0,
            subTitleColor: { h: 0.0, s: 0.0, l: 0.0, a: 0.0 },
            subTitleBold: false,
            subTitleItalic: false,
            aggregateDollarsTooltipLabel: '',
            displayAggregateDollarsTooltip: false,
            displayUniqueCountTooltip: false,
            uniqueCountTooltipLabel: '',
            enableGradientMap: false,
            enableBreakpointMap: false,
            enableBreakpointLegend: false,
            gradientMapSourceType: 'Dollars',
            breakpoints: [],
            gradientScale: 10,
            legendColor: { h: 0.0, s: 0.0, l: 0.0, a: 0.0 },
            customizeStates: false,
            selectedStates: [],
        },
    },
    gradientMapBoundaryLookup: {},
}

export const reducer = (state = initialState, action: ActionsUnion<typeof actions>) => {
    switch (action.type) {
        case types.ASSIGN_MAP_SETTINGS:
            return {
                ...state,
                instanceSettings: action.payload,
            }
        case types.GENERATE_MAP:
            return {
                ...state,
                map: getMap(action.payload as GenerateMapPayload),
            }
        case types.POPULATE_MAP_DATA:
            const mapDataSource = getMapDataSource(state.instanceSettings.scoreboardTypeId)
            const data = populate(action.payload as MapDataItem[], mapDataSource.data)
            const newState = setGradientMapBoudaryLookup(state, mapDataSource.data)
            return {
                ...newState,
                data,
            }
        default:
            return state
    }
}
